export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ReadOnlyField.vue?vue&type=template&id=2d22e418&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/ReadOnlyField.vue?vue&type=template&id=2d22e418&scoped=true&
// module id = 1585
// module chunks = 0